import User from "../../pages/user/User";

export default function UserView() {
  return <User /> 
}